<template>
    <div class="footer">
        <div class="container">
            <div class="row mb-4">
                <div class="col-md-12">
                    <p>{{ $root.t('Aviso: Como para qualquer atividade física, você deve seguir todas as orientações e instruções de segurança, atentando-se à correta execução dos exercícios para respeitar sua condição física e sua saúde. Se você possui problemas de coração, dores no peito ou no tórax, desequilíbrio, tontura ou perda de consciência, problema ósseo ou articular, está em tratamento para pressão arterial ou de coração, realiza tratamento contínuo ou submeteu-se a alguma cirurgia recentemente, não faça esses treinos sem a indicação de um especialista.') }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    computed : {
        ...mapGetters([
            'banners'
        ])
    }
}
</script>

<style lang="scss" scoped>
    @import "@/assets/scss/settings/_variables.scss";

    .footer {
        color: $c_gray-light;
        font-size: 11px;
        padding: 20px 0 0 0;
    }
</style>
